import { Component, OnInit, ViewChild, ElementRef, Input, AfterViewInit, HostListener } from "@angular/core";
import { ServiceStock } from "../service-stock.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
// import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

// declare var $: any;

@Component({
    selector: 'app-gotx-modal',
    templateUrl: './gotxModal.component.html',
    styleUrls: ['./gotxModal.component.scss']
})

export class gotxModalComponent implements OnInit, AfterViewInit {

    @Input('selectedMenu') selectedMenu: string;
    @Input('params') params: any;

    modalHeader = '';
    isDragging = false;
    currentX = 0;
    currentY = 0;
    initialX = 0;
    initialY = 0;
    xOffset = 0;
    yOffset = 0;
    modalDialog: HTMLElement;
    modalHeaderEl: HTMLElement;

    constructor(private services: ServiceStock, public activeModal: NgbActiveModal) { }

    ngOnInit() {
        this.modalHeader = this.selectedMenu;

        if (this.params) {
            // console.log("in params", this.params)
            // let data = JSON.parse(this.params);
            // if (data != null) {
            //     console.log("in data")
            if (this.params.type == "Alert" || this.params.type == "modifyCancel")
                this.modalHeader = this.params.title;
            // }    
        }
    }

    ngAfterViewInit() {
        // Wait for ng-bootstrap to finish positioning the modal
        setTimeout(() => {
            this.initDraggable();
        }, 300);
    }

    initDraggable() {
        const modalElement = document.querySelector('.modal-dialog');
        const modalHeaderElement = document.querySelector('.modal-header');
        
        if (modalElement && modalHeaderElement && this.isOrderEntryModal()) {
            this.modalDialog = modalElement as HTMLElement;
            this.modalHeaderEl = modalHeaderElement as HTMLElement;
            
            // Only set cursor, don't override existing positioning
            this.modalHeaderEl.style.cursor = 'move';
            
            // Don't modify any positioning styles initially
            // Let ng-bootstrap handle initial centering - we'll switch to fixed on first drag
            
            // Initialize offsets
            this.xOffset = 0;
            this.yOffset = 0;
            this.currentX = 0;
            this.currentY = 0;
            this.initialX = 0;
            this.initialY = 0;
            
            this.modalHeaderEl.addEventListener('mousedown', this.dragStart.bind(this));
            document.addEventListener('mousemove', this.drag.bind(this));
            document.addEventListener('mouseup', this.dragEnd.bind(this));
        }
    }

    isOrderEntryModal(): boolean {
        return ['Buy', 'Sell', 'OrderEntry'].includes(this.selectedMenu);
    }

    dragStart(e: MouseEvent) {
        if (this.isOrderEntryModal() && this.modalHeaderEl && this.modalDialog && e.target && this.modalHeaderEl.contains(e.target as Node)) {
            // Don't allow dragging if clicking on the close button
            const target = e.target as HTMLElement;
            if (target.closest('.close') || target.closest('button.close')) {
                return;
            }

            e.preventDefault();
            
            // Get current modal position
            const rect = this.modalDialog.getBoundingClientRect();
            
            // Store the initial mouse position (where user clicked)
            this.initialX = e.clientX;
            this.initialY = e.clientY;
            
            // Store the modal's current top-left position relative to viewport
            // We'll use this to calculate movement
            const modalLeft = rect.left;
            const modalTop = rect.top;
            
            // Calculate offset from mouse click to modal top-left corner
            // This maintains the relative position during drag
            const offsetFromModalX = this.initialX - modalLeft;
            const offsetFromModalY = this.initialY - modalTop;
            
            // Store these offsets - they represent where in the modal the user clicked
            this.initialX = offsetFromModalX;
            this.initialY = offsetFromModalY;
            
            // Store modal's current position
            this.xOffset = modalLeft;
            this.yOffset = modalTop;
            this.currentX = modalLeft;
            this.currentY = modalTop;

            if (e.target === this.modalHeaderEl || this.modalHeaderEl.contains(e.target as Node)) {
                this.isDragging = true;
            }
        }
    }

    drag(e: MouseEvent) {
        if (this.isDragging && this.modalDialog) {
            e.preventDefault();
            
            // Calculate new position: mouse position minus the offset from where user clicked
            // This makes the modal follow the mouse while maintaining the click position
            this.currentX = e.clientX - this.initialX;
            this.currentY = e.clientY - this.initialY;

            // Get viewport dimensions
            const viewportWidth = window.innerWidth;
            const viewportHeight = window.innerHeight;
            
            // Get header dimensions to ensure it stays visible and accessible
            const headerHeight = this.modalHeaderEl ? this.modalHeaderEl.offsetHeight : 50;
            const headerWidth = this.modalHeaderEl ? this.modalHeaderEl.offsetWidth : 300;
            
            // Constrain X position: keep header within viewport horizontally
            // Ensure header is always accessible for dragging
            const minX = 0; // Modal left edge (where header starts) can't go beyond viewport left
            const maxX = Math.max(0, viewportWidth - headerWidth); // Header right edge must be within viewport
            
            // Constrain Y position: keep header within viewport vertically  
            // Header must always be visible and accessible for dragging
            const minY = 0; // Modal top edge (where header starts) can't go above viewport top
            const maxY = Math.max(0, viewportHeight - headerHeight); // Header bottom edge must be within viewport
            
            // Apply constraints
            this.currentX = Math.max(minX, Math.min(maxX, this.currentX));
            this.currentY = Math.max(minY, Math.min(maxY, this.currentY));

            // Use fixed positioning - modal follows mouse directly
            // Only apply positioning when actually dragging (not on first click)
            if (!this.modalDialog.style.position || this.modalDialog.style.position !== 'fixed') {
                this.modalDialog.style.position = 'fixed';
                this.modalDialog.style.margin = '0';
                this.modalDialog.style.transform = 'none';
            }
            
            this.modalDialog.style.left = this.currentX + 'px';
            this.modalDialog.style.top = this.currentY + 'px';
        }
    }

    dragEnd(e: MouseEvent) {
        // Update offsets to the final position for next drag session
        this.xOffset = this.currentX;
        this.yOffset = this.currentY;
        this.isDragging = false;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        if (this.modalDialog && this.isOrderEntryModal()) {
            // On resize, recenter the modal
            this.xOffset = 0;
            this.yOffset = 0;
            this.currentX = 0;
            this.currentY = 0;
            this.initialX = 0;
            this.initialY = 0;
            // Reset to ng-bootstrap's default centering
            this.modalDialog.style.position = '';
            this.modalDialog.style.left = '';
            this.modalDialog.style.top = '';
            this.modalDialog.style.margin = '';
            this.modalDialog.style.transform = '';
        }
    }
    handleSelectedRow(event) {
        this.selectedMenu = event;
    }

    updateWindowHeader(event){
        this.modalHeader = event;
    }
}